import { __extends } from 'tslib';
import React__default from 'react';
var VisualElementHandler = /** @class */function (_super) {
  __extends(VisualElementHandler, _super);
  function VisualElementHandler() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * Update visual element props as soon as we know this update is going to be commited.
   */
  VisualElementHandler.prototype.getSnapshotBeforeUpdate = function () {
    this.updateProps();
    return null;
  };
  VisualElementHandler.prototype.componentDidUpdate = function () {};
  VisualElementHandler.prototype.updateProps = function () {
    var _a = this.props,
      visualElement = _a.visualElement,
      props = _a.props;
    if (visualElement) visualElement.setProps(props);
  };
  VisualElementHandler.prototype.render = function () {
    return this.props.children;
  };
  return VisualElementHandler;
}(React__default.Component);
export { VisualElementHandler };